
import barba from '@barba/core';
//import anime from 'animejs';

export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            this.init()
        })
        barba.hooks.after((data) => {
            this.init()
        });
    }
    init (){

        const lowerMain = document.querySelector(".c-lower__heading--primary")
        const lowerMainTit = document.querySelector(".c-lower__heading--primary .c-section__tit--primary")
        if(lowerMain){
            setTimeout(function(){
                lowerMain.classList.add('active');
                lowerMainTit.classList.add('visible');
            },750)
        }
    }
}